import React, { useState } from 'react';
import GridOnOutlinedIcon from '@mui/icons-material/GridOnOutlined';
import { useAppDispatch, useAppSelector } from 'src/store';
import { getIsSiteMenuOpen } from 'src/global/state/site-menu/siteMenuSelector';
import classNames from 'classnames';
import { getAppRoutesAvailability } from 'src/routes/state/routesSelector';
import { useLocation } from 'react-router-dom';
import { openSiteMenu } from 'src/global/state/site-menu/siteMenuSlice';
import ChevronButton from 'src/shared/components/chevron-button/ChevronButton';
import { tableRouteSettings } from 'src/app/tables/Tables';
import { FeatureType } from 'src/shared/types';
import useAppNavigation from 'src/shared/hooks/useAppNavigation';
import useFeature from 'src/shared/hooks/useFeature';
import useProject from 'src/shared/hooks/useProject';
import styles from '../SiteMenu.module.scss';

const TablesMenu = () => {
    const [isExpanded, setIsExpanded] = useState(false);
    const isOpen = useAppSelector(getIsSiteMenuOpen);
    const appRoutesAvailability = useAppSelector(getAppRoutesAvailability);
    const dispatch = useAppDispatch();
    const navigate = useAppNavigation();
    const { pathname } = useLocation();
    const { hasFeature } = useFeature();
    const { isStarterProject } = useProject();
    const isHabitatInsightsProject = hasFeature({
        feature: FeatureType.HLCA,
    });

    const isEDnaProject = hasFeature({
        feature: FeatureType.EDNA,
    });

    if (!appRoutesAvailability.tables) {
        return null;
    }

    const getMenuItemClassNames = () => {
        return classNames(styles.menuItem, {
            [styles.menuItemOpen]: isOpen,
            [styles.menuItemActive]: pathname.startsWith('/tables'),
        });
    };

    const getMenuChildItemClassNames = (path: string) => {
        return classNames(styles.menuItem, styles.menuItemChild, {
            [styles.menuItemOpen]: isOpen,
            [styles.menuItemActive]: pathname.includes(path),
        });
    };

    const toggleExpanded = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
        e.stopPropagation();
        e.preventDefault();

        setIsExpanded(!isExpanded);
    };
    const openMenu = () => {
        dispatch(openSiteMenu());
        setIsExpanded(true);
    };

    return (
        <>
            <div className={getMenuItemClassNames()} onClick={openMenu} data-testid='tables-menu-item'>
                <div className={styles.icon}>
                    <GridOnOutlinedIcon />
                </div>
                <div className={styles.label}>Tables</div>
                {isOpen && (
                    <ChevronButton
                        className={styles.chevron}
                        animate={true}
                        direction={isExpanded ? 'down' : 'right'}
                        onClick={e => toggleExpanded(e)}
                    />
                )}
            </div>
            {isOpen && isExpanded && (
                <>
                    {(isStarterProject || isEDnaProject) && (
                        <div
                            className={getMenuChildItemClassNames(tableRouteSettings.sampleMetrics.path)}
                            onClick={navigate.toSampleMetricsTable}
                            data-testid='sample-metrics-table-menu-item'
                        >
                            <div className={styles.label}>{tableRouteSettings.sampleMetrics.name}</div>
                        </div>
                    )}
                    {isHabitatInsightsProject && (
                        <div
                            className={getMenuChildItemClassNames(tableRouteSettings.habitatInsightsMetrics.path)}
                            onClick={navigate.toHabitatInsightsMetricsTable}
                            data-testid='habitat-insights-metrics-table-menu-item'
                        >
                            <div className={styles.label}>{tableRouteSettings.habitatInsightsMetrics.name}</div>
                        </div>
                    )}
                </>
            )}
        </>
    );
};

export default TablesMenu;
